<template>
  <div class="grid grid-cols-1 lg:grid-cols-2 gap-5" data-testid="impact-verhalten-detail">
    <div>
      <p class="text-[13px] font-semibold text-[var(--color-dark)] mb-3 m-0">
        {{ $t('UserProjects.impactAnalysis.verhalten.tbiTitle') }}
      </p>
      <CockpitTbiTrendChart :bars="tbiBars" />
      <p class="text-[12px] text-[var(--color-disabled)] mt-2 mb-0">
        n={{ tbiCurrent?.n ?? 0 }} · {{ periodLabel }}
      </p>
    </div>

    <ImpactDimensionAnomalyBars :dimensions="dimensions" />

    <div class="lg:col-span-2">
      <ImpactComingSoonPanel
        :title="$t('UserProjects.impactAnalysis.comingSoon.affectedTeamsTitle')"
        :message="$t('UserProjects.impactAnalysis.comingSoon.affectedTeams')"
        test-id="impact-coming-soon-teams"
      />
    </div>
  </div>
</template>

<script>
import CockpitTbiTrendChart from '@/components/CustomerApp/UserProjects/Cockpit/CockpitTbiTrendChart.vue';
import ImpactComingSoonPanel from './ImpactComingSoonPanel.vue';
import ImpactDimensionAnomalyBars from './ImpactDimensionAnomalyBars.vue';

export default {
  name: 'ImpactVerhaltenDetail',
  components: { CockpitTbiTrendChart, ImpactComingSoonPanel, ImpactDimensionAnomalyBars },
  props: {
    tbiBars: { type: Array, default: () => [] },
    tbiCurrent: { type: Object, default: null },
    periodLabel: { type: String, default: '' },
    dimensions: { type: Object, default: null },
  },
};
</script>
